import { HttpClient } from '@angular/common/http';
import { Observable, of, switchMap } from 'rxjs';
import { Injectable } from '@angular/core';
import { AuthSharedService, IConfrontationRbeResponse } from '@core';
import { environment } from '@environments/environment';

@Injectable({
	providedIn: 'root'
})
export class BeneficiaireEffectifService {
	get tenantKey() {
		return this.authService.currentTenantKey;
	}

	constructor(
		private http: HttpClient,
		private authService: AuthSharedService
	) {}

	getRbePdfUrl(siren: string): Observable<IConfrontationRbeResponse> {
		return  this.http.get<IConfrontationRbeResponse>(`${environment.apiUrl}/t/${this.tenantKey}/BeneficiaireEffectif?siren=${siren}`);
	}
}
